import { normalizeInputDate, buildDateTime } from '@/utils/date';

import { ConsultationRequest } from '@/types/consultations';

import { UUID } from '@/utils/uuid';
import { Specialization } from '@/types/common';

const HOME_CONSULTATION_TYPE = 'Консультация на дому';

type BackendConsultationDoctor = {
    doctorId: number,
    doctorFullName: string,
}

type BackendConsultationTime = {
    startTime: string, // 20.10.2021 09:15
    endTime: string, // "20.10.2021 10:15"
    duration: number, // minutes
}

type BackendConsultationBase = {
    id: UUID,
    patientFullName: string,
    patientId: number,
    specialization: Specialization,
    type: string,
    address?: string,
}

type BackendConsultationRequest =
    BackendConsultationBase
    & Partial<BackendConsultationDoctor>
    & Partial<BackendConsultationTime>

const normalizeDateTime = (datetime: string) => {
    const [date, time] = datetime.split(' ');
    const formattedDate = normalizeInputDate(date);

    return buildDateTime(formattedDate, time);
}

export const transformConsultationRequest = (request: BackendConsultationRequest): ConsultationRequest => {
    const consultationRequest: ConsultationRequest = {
        id: request.id,
        type: request.type,
        patient: {
            id: request.patientId,
            name: request.patientFullName,
        },
        specialization: request.specialization,
        doctor: null,
    }

    if (request.address) {
        consultationRequest.address = request.address;
    }

    if (request.type === HOME_CONSULTATION_TYPE) {
        consultationRequest['price'] = '';
    }

    if (request.doctorId && request.doctorFullName) {
        consultationRequest.doctor = {
            id: request.doctorId,
            value: request.doctorFullName,
        }
    }

    if (request.startTime && request.endTime) {
        consultationRequest.time = {
            start: normalizeDateTime(request.startTime),
            end: normalizeDateTime(request.endTime)
        }

        consultationRequest.duration = request.duration;
    }

    return consultationRequest;
}
